<script>
    export default {

    }
</script>

<template>
    <span class="loader"></span>
</template>

<style scoped>
.loader {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  border-top: 2px solid var(--secondary-color);
  border-right: 2px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: 0px;
}

.btn .loader {
  border-top: 2px solid #FFF;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
} 

</style>